import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, type PropType } from 'vue';
import { useI18n } from 'vue-i18n';

import { modalVariant, type ModalVariant } from '@exchange/libs/modals/src';


export default /*#__PURE__*/_defineComponent({
  __name: 'ResetColorChangeModal',
  props: {
  variant: { type: String as PropType<ModalVariant>, default: modalVariant.dark },
},
  emits: ["please-reset", "do-no-reset"],
  setup(__props, { emit: __emit }) {


const emit = __emit;

const { t } = useI18n({ useScope: 'global' });

const title = computed(() => t('modules.charting.resetColorScheme.title'));
const message = computed(() => t('modules.charting.resetColorScheme.message'));

return (_ctx: any,_cache: any) => {
  const _component_x_button = _resolveComponent("x-button")!
  const _component_x_modal = _resolveComponent("x-modal")!

  return (_openBlock(), _createBlock(_component_x_modal, {
    class: "reset-color-change-modal",
    variant: __props.variant,
    title: title.value,
    type: "base"
  }, {
    content: _withCtx(() => [
      _createElementVNode("p", null, _toDisplayString(message.value), 1)
    ]),
    buttons: _withCtx(() => [
      _createVNode(_component_x_button, {
        ref: "ok",
        variant: "outline",
        text: _ctx.$t('modules.charting.resetColorScheme.button.restore'),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('please-reset')))
      }, null, 8, ["text"]),
      _createVNode(_component_x_button, {
        ref: "ok",
        variant: "primary",
        text: _ctx.$t('modules.charting.resetColorScheme.button.keep'),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('do-no-reset')))
      }, null, 8, ["text"])
    ]),
    _: 1
  }, 8, ["variant", "title"]))
}
}

})